import { MutationKey, QueryKey } from '@tanstack/react-query';

export const userSessionsKey: QueryKey = ['services2', 'userSessions'];
export const queryUserSessionsKey: QueryKey = userSessionsKey.concat('queryUserSessions');
export const getActiveSessionsKey: QueryKey = userSessionsKey.concat('getActiveSessions');
export const logOutFromSessionKey: MutationKey = userSessionsKey.concat('logOutFrom');
export const logOutFromAllSessionsKey: MutationKey = userSessionsKey.concat('logOutEveryWhere');
